import {
  get,
  put,
  post,
  del
} from '../configApi'
export async function getLive(body) {
  return await get(`/livestream/list/admin`, body)
}

export async function getLiveStreamKey() {
  return await get(`/livestreamkey/list/teacher`)
}
export async function getLiveStreamStudio(data) {
  return await get(`/livestream/live/studio`, data)
}
export async function setLiveStreamKey(body) {
  return await put(`/livestream/live/addkeystudio`, body)
}
export async function startLiveStream(body) {
  return await get(`/livestream/live/startstream`, body)
}
export async function cancelLiveStream(body) {
  return await get(`/livestream/live/clearkey`, body)
}
export async function stopLiveStream(body) {
  return await get(`/livestream/live/stopstream`, body)
}
export async function insertLive(body) {
  return await post(`/livestream/manage/insert`, body)
}
export async function deleteLive(body) {
  return await del(`/livestream/manage/delete`, body)
}
export async function getJoinedLearner(body) {
  return await get(`/livestream/report/studio/learner`, body)
}
export async function getRegisteredLearner(body) {
  return await get(`/livestream/report/studio/register`, body)
}
export async function getOnlineLearner(body) {
  return await get(`/livestream/report/studio/online`, body)
}
export async function getMessageLearner(body) {
  return await get(`/livestream/report/studio/mail`, body)
}
export async function getTotalLearner(body) {
  return await get(`/livestream/report/studio/header`, body)
}

export async function getCheckStudentList(data) {
  return await get(`/livestream/live/listcheckstudent`, data)
}
export async function requestCheckStudent(body) {
  return await put(`/livestream/live/checkstudent`, body)
}
export async function sendQuiz(body) {
  return await put(`/livestream/live/sendquiz`, body)
}
export async function reportQuiz(body) {
  return await get(`/livestream/report/quiz`, body)
}
export async function reportChoice(body) {
  return await get(`/livestream/report/choice`, body)
}
export async function reportLeaderBoard(body) {
  return await get(`/livestream/report/allquizstudent`, body)
}

export async function getLiveDetial(body) {
  return await get(`/livestream/manage/detail`, body)
}

export async function updateLive(body) {
  return await put(`/livestream/manage/update`, body)
}
export async function insertURL(body) {
  return await post(`/livestream/manage/url/insert`, body)
}
export async function updateURL(body) {
  return await put(`/livestream/manage/url/update`, body)
}
export async function deleteURL(body) {
  return await del(`/livestream/manage/url/delete`, body)
}
export async function insertPdf(body) {
  return await post(`/livestream/manage/pdf/insert`, body)
}
export async function updatePdf(body) {
  return await put(`/livestream/manage/pdf/update`, body)
}
export async function deletePdf(body) {
  return await del(`/livestream/manage/pdf/delete`, body)
}
export async function insertImage(body) {
  return await post(`/livestream/manage/image/insert`, body)
}
export async function deleteImage(body) {
  return await del(`/livestream/manage/image/delete`, body)
}
export async function getChatRoomList(body) {
  return await get(`/livestream/chatroom/list/list`, body)
}
export async function insertChatRoom(body) {
  return await post(`/livestream/chatroom/manage/insert`, body)
}
export async function updateChatRoom(body) {
  return await put(`/livestream/chatroom/manage/update`, body)
}
export async function deleteChatRoom(body) {
  return await del(`/livestream/chatroom/manage/delete`, body)
}